function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#47dfed;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(35.371 35.371) rotate(180)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M17.686,0A17.686,17.686,0,1,0,35.371,17.686,17.661,17.661,0,0,0,17.686,0Zm0,33.006A15.321,15.321,0,1,1,33.006,17.685,15.287,15.287,0,0,1,17.686,33.006Z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(14.386 8.847)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M147.394,92.76l-7.777-7.777a1.17,1.17,0,0,0-1.654,1.654L144.8,93.47l-6.833,6.833a1.151,1.151,0,0,0,0,1.654,1.067,1.067,0,0,0,.827.351,3.665,3.665,0,0,0,.944-.234l7.66-7.66a1.067,1.067,0,0,0,.351-.827A1.08,1.08,0,0,0,147.394,92.76Z",
  transform: "translate(-137.612 -84.632)"
})));

var SvgChevronLeft = function SvgChevronLeft(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35.371,
    height: 35.371,
    viewBox: "0 0 35.371 35.371",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChevronLeft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chevron-left.7411e33d.svg";
export { ForwardRef as ReactComponent };